import { LinkReference, LinkReferenceTypes, ReferenceLink } from "../../../DTOs";
import { basicValidation } from "../basicValidation";

export const referenceLinkFieldValidation = {
    referenceLink: {
        reference: (value: LinkReference) => {
            if(typeof value !== 'object' || value === null)
                return false;

            if(!LinkReferenceTypes.includes(value.type))
                return false;
            
            if(!basicValidation.resourceId.isValid(value.id))
                return false;

            return true;
        },
        link:(value:ReferenceLink) => {
            if(typeof value !== 'object' || value === null)
                return false;

            if(!title(value.title))
                return false;

            if(!description(value.description))
                return false;

            if(!url(value.url))
                return false;

            if(value.iconName !== null && !basicValidation.resourceText.isValid(value.iconName, true, 100))
                return false;

            return true;
        },
        title,
        description,
        url
    }
}

function title(value:string){
    return basicValidation.resourceText.isValid(value, false, 100);
}

function description(value:string){
    return basicValidation.resourceText.isValid(value, true, 1000);
}

function url(value:string){
    // Only simple text validation is performed,
    // since the full collection is submitted.
    // Only one link in the collection can be edited and saved at a time.
    // If more than one link is invalid (existing links with errors), none are saved.
    return basicValidation.isValidText(value, 500, false);
}
